import { useTranslation } from '@modernloop/i18n';
import { CheckIcon, MoreIcon, OpenInNewTabIcon, SettingsIcon } from '@modernloop/shared/icons';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

type NotificationHeaderMenuProps = {
  unreadCount: number;
  onMarkAllRead: () => void;
  onOpenSettings: () => void;
  onOpenNotifications: () => void;
  showOpenNotifications?: boolean;
};

/** Horizontal overflow menu with inbox-level actions, reused by the popover header and the page chrome. */
const NotificationHeaderMenu = ({
  unreadCount,
  onMarkAllRead,
  onOpenSettings,
  onOpenNotifications,
  showOpenNotifications = true,
}: NotificationHeaderMenuProps) => {
  const { t } = useTranslation();
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const handleAction = (action: () => void) => () => {
    setMenuAnchor(null);
    action();
  };

  return (
    <>
      <IconButton
        aria-label={t('hiring-dashboard-nav:nav.notificationInbox.actions')}
        onClick={(event) => setMenuAnchor(event.currentTarget)}
        size="small"
      >
        <MoreIcon />
      </IconButton>
      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        {unreadCount > 0 && (
          <MenuItem onClick={handleAction(onMarkAllRead)}>
            <CheckIcon fontSize="small" sx={{ mr: 1 }} />
            {t('hiring-dashboard-nav:nav.notificationInbox.markAllRead')}
          </MenuItem>
        )}
        <MenuItem onClick={handleAction(onOpenSettings)}>
          <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
          {t('hiring-dashboard-nav:nav.notificationInbox.notificationSettings')}
        </MenuItem>
        {showOpenNotifications && (
          <MenuItem onClick={handleAction(onOpenNotifications)}>
            <OpenInNewTabIcon fontSize="small" sx={{ mr: 1 }} />
            {t('hiring-dashboard-nav:nav.notificationInbox.openNotifications')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default NotificationHeaderMenu;
